module.exports = {"654322100":"库额尔齐斯镇","654322101":"可可托海镇","654322102":"恰库尔图镇","654322103":"喀拉通克镇","654322104":"杜热镇","654322200":"吐尔洪乡","654322202":"库尔特乡","654322203":"克孜勒希力克乡","654322204":"铁买克乡","654322205":"喀拉布勒根乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654322.json
// module id = 3145
// module chunks = 0